'use client';

import * as React from 'react';
import { useAccount } from 'wagmi';

import useWeb3Wallet from 'lib/web3/useWallet';
import { toaster } from 'toolkit/chakra/toaster';

import useEnsureChain from './useEnsureChain';

export default function useAddChainClickV2() {
  const ensureChain = useEnsureChain();
  const web3Wallet = useWeb3Wallet({ source: 'Header' });

  const { address, connector } = useAccount();
  const isConnected = Boolean(address) && Boolean(connector);

  return React.useCallback(async() => {
    if (!isConnected) {
      web3Wallet.openModal();
      return;
    }

    try {
      const res = await ensureChain();

      toaster.success({
        title: 'Success',
        description: res?.changed ?
          'Network added/switched successfully.' :
          'Already on the correct network.',
      });
    } catch (e: any) {
      toaster.error({
        title: 'Action required',
        description:
          e?.message ??
          'Please open your wallet app and approve the network request.',
      });
    }
  }, [ isConnected, web3Wallet, ensureChain ]);
}
